import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeTeam01 from './HomeTeam_01';
import HomeTeam02 from './HomeTeam_02';
import HomeTeam03 from './HomeTeam_03';
import HomeTeam04 from './HomeTeam_04';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        <>
            {
            layout.current === 'home-team-01' ?
                <HomeTeam02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-team-02' ?
                <HomeTeam02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-team-03' ?
                <HomeTeam03 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-team-04' ?
                <HomeTeam04 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
                <HomeTeam01 pag_welcome={pw.current} dados_config={dados_config.current} />
            }
        </>
    )
}
